<template>
    <div class="ChatPage">
        <div class="leftcontent" :class="isfold?'position':''">
            <div class="broadside" :class="isfold?'flod':''">
                <div class="ChatPagelogo"><img src="../../../public/img/chatgpt/icon_logo.png"></div>
                <el-button type="primary" class="sessionbtn" @click="createtalk"><i><img src="../../../public/img/chatgpt/ic_add.png" alt=""></i>新建会话</el-button>
                <ul>
                    <li v-for="item of talkList" @click="gethistoryquestionanswer(item)" :style="item.talkTypeKey==talkTypeKey?'color:#409EFF':'color:#fff'">
                        <i><img src="../../../public/img/chatgpt/ic_news.png"></i>
                        <span>{{item.talkTypeNM}}</span>
                    </li>
                </ul>
                <div class="footer">
                    <div class="vip_up">
                        升级会员
                        <img src="../../../public/img/chatgpt/icon_vip.png" >
                    </div>
                    <div class="user_icon">
                        <img src="../../../public/img/chatgpt/ic_collapse.png" >
                        links
                        <span>···</span>
                    </div>
                </div>
                <img src="../../../public/img/chatgpt/ic_collapse.png" class="fold_icon" @click="boroadside">
            </div>
        </div>

        <div class="subMain" :class="isfold?'subjectcontent':''">
            <div class="subject">
                <div class="dialogue" ref="dialogue">
                    <ul ref="dialogueheight">
                        <li v-for="item of chatData">
                            <img :src="item.img"  class="avatar">
                            <div v-html="item.content" disabled="disabled"></div>
                        </li>
                    </ul>
                    <el-button v-show="CreateStatu" icon="el-icon-video-pause" class="stopcreat" @click="ClickCreatestatu">停止生成</el-button>
                </div>
                <div class="problem">
                    <i></i>
                    <div class="QA">
                        <el-input type="textarea" :disabled="!isclick" v-model="problem" class="input" placeholder="输入你想要提问的内容" @keyup.enter.native="sendClick"></el-input>
                    </div>
                    
                    <img src="../../../public/img/chatgpt/ic_send.png" class="send_icon" @click.passive="sendClick" >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var setin;
export default{
    name:'ChatPage',
    data() {
        return {
            proimg:require('@/assets/icon_chatbot.png'),
            problem:'',
            isfold:false,
            chatData:[],
            elementHeight:0,
            isclick:true,
            verbatimstrh:'',
            talkTypeNM:'',//话题
            talkList:'',
            talkTypeKey:'',
            CreateStatu:false
        }
    },
    watch:{
        chatData:{
            deep: true,
            handler(newVal,oldVal){
                if(this.verbatimstrh!=this.$refs.dialogueheight.offsetHeight){
                    this.verbatimstrh=this.$refs.dialogueheight.offsetHeight;
                    this.$refs.dialogue.scrollTop=this.$refs.dialogueheight.offsetHeight;
                }
                
            },
        },
    },
    mounted() {
        this.gettalktopic();
    },
    methods: {
        boroadside(){
            this.isfold=!this.isfold;
        },
        sendClick(){
            var _this=this;
            if(!this.problem){
                this.$message({
                    message: '发送内容不能为空',
                    type: 'warning'
                    });
                return false;
            };
            if(!this.isclick){return false;}
            this.isclick=false;
            let str=[{img:require('@/assets/icon_chat.png'),content:this.problem},{img:this.proimg,content:'数据请求中···'}];
            this.chatData=this.chatData.concat(str);
            this.setTimeverbatim();
            if(this.talkTypeKey==''){
                this.talkTypeNM=this.problem.substring(0,8);
                this.talktopic();
            }else{
                this.Chatconversation();
            }
            
        },

        // 聊天对话
        Chatconversation(){
            this.$Http_Post('/chatai/chat',{prompt:this.problem,talkTypeKey:this.talkTypeKey}).then(res=>{
                if(res.Code==0){
                    this.problem='';
                    this.chatData.pop();
                    this.chatData.push({img:this.proimg,content:''});
                    this.verbatim(res.Data.replace(/[\r\n]/g,'<br/>'));
                    
                }else{
                    this.isclick=true;
                    this.$message({message:res.Message,type: 'error'});
                }
            });
        },

        // 创建新的会话
        createtalk(){
            this.chatData=[];
            this.talkTypeKey='';
            this.talkTypeNM='';
        },

        // 添加话题
        talktopic(){
            this.$Http_Post('chatai/addtalktopic',{talkTypeNM:this.talkTypeNM}).then(res=>{
                if(res.Code==0){
                    this.talkTypeKey=res.Data.talkTypeKey;
                    this.Chatconversation();
                    this.gettalktopic();
                }else{
                    this.$message({message:res.Message,type: 'error'});
                }
            })
        },

        // 获取话题列表
        gettalktopic(){
            this.$Http_Post('chatai/gettalktopic').then(res=>{
                if(res.Code==0){
                    this.talkList=res.Data;
                }else{
                    this.$message({message:res.Message,type: 'error'});
                }
            })
        },

        // 获取话题历史聊天记录
        gethistoryquestionanswer(e){
            this.chatData=[];
            this.talkTypeKey=e.talkTypeKey;
            
            this.$Http_Post('chatai/gethistoryquestionanswer',{talkTypeKey:e.talkTypeKey}).then(res=>{
                if(res.Code==0){
                    for(let item of res.Data){
                        let talkData={img:'',content:''};
                        if(item.talkFlg==0){
                            talkData['img']=require('@/assets/icon_chat.png');
                            talkData['content']=item.talk.replace(/[\r\n]/g,'<br/>');
                        }else{
                            talkData['img']=this.proimg;
                            talkData['content']=item.talk.replace(/[\r\n]/g,'<br/>');
                        }
                        this.chatData.push(talkData);
                    }
                }else{
                    this.$message({message:res.Message,type: 'error'});
                }
            });
        },

        // 延迟加载
        setTimeverbatim(){
            var _this=this;
            var setTime=setTimeout(function(){
                _this.$refs.dialogue.scrollTop=_this.$refs.dialogueheight.offsetHeight;
                clearTimeout(setTime);
            },100);
        },
        // 文字逐字出现
        verbatim(val){
            let i=0;
            var _this=this;
            var verbatimstr=this.chatData[this.chatData.length-1];
            this.CreateStatu=true;
            setin=setInterval(function(){
                if(i<val.length){
                    verbatimstr['content']+=val[i];
                    i++;
                }else{
                    _this.isclick=true;
                    _this.CreateStatu=false;
                    clearInterval(setin);
                    
                }
            },20);
        },
        // 停止生成
        ClickCreatestatu(){
            clearInterval(setin);
            this.CreateStatu=false;
            this.isclick=true;
        }
    },
}
</script>
<style>
img{display: block;}
.ChatPage{background:#16171A;color: #fff;display: flex;width: 100%;height:100vh;overflow-x: hidden;}
.leftcontent{position: relative;width:100%;max-width: 280px;}
.ChatPage .broadside{background: #282A30;text-align: center;position: absolute;top:0;left:0;width:100%;height:100%;}
.ChatPage .broadside .ChatPagelogo{margin:0 auto;display: block;}
.ChatPage .broadside .ChatPagelogo img{width:100%;}
.ChatPage .broadside .sessionbtn{max-width: 335px;width:80%;font-size:18px;display: inline-flex;align-items: center;justify-content: center;padding: 1.2em 0;}
.ChatPage .broadside .sessionbtn i{max-width:24px;width: 100%;margin-right: 10px;display: inline-block;}
.ChatPage .broadside .sessionbtn span{display: flex;align-items: center;}
.ChatPage .broadside ul{max-height: 60vh;overflow-y:auto;margin:3vh 20% 0;}
.ChatPage .broadside ul li{font-size: 16px;display: flex;align-items: center;margin:20px 0;cursor: pointer;}
.ChatPage .broadside ul li i{max-width: 24px;display: inline-block;width:100%;margin-right: 10px;}
.ChatPage .broadside .footer{position: absolute;bottom:0;left:0;width:100%;padding-bottom:1vh;}
.ChatPage .broadside .footer .vip_up{padding:13px 32px;color: #99AABA;box-shadow: 0px -1.33px 0px  #000000;text-align: left;cursor: pointer;}
.ChatPage .broadside .footer .vip_up img{width:40px;display: inline-block;}
.ChatPage .broadside .footer .user_icon{display:flex;align-items: center;position: relative;position: relative;box-shadow: 0px -1.33px 0px  #000000;padding:3vh 32px;cursor: pointer;}
.ChatPage .broadside .footer .user_icon img{margin-right:4%;}
.ChatPage .broadside .footer .user_icon span{position: absolute;right:10%;font-size:4vh;}
.ChatPage .broadside .fold_icon{width: 30px;position:absolute;top:20px;right:-40px;z-index:2;cursor: pointer;}
.ChatPage .broadside.flod{left:-100%;}
.ChatPage .position{position: absolute;}
.ChatPage .stopcreat{background: #2E3033;border:none;color: #99AABA;float: right;margin-top:20px;}

.ChatPage .subMain{margin:auto;position: relative;background: #16171A;width: 980px;}
.ChatPage .subject{margin:0 30px;position: relative;height:100vh;}
.ChatPage .subject .dialogue{max-width: 980px;max-height: 85vh;overflow-y: auto;height:85vh;padding:0 10px;overflow-x:hidden;scroll-behavior: smooth;transition: transform 0.5s ease-out;}
.ChatPage .subject .dialogue ul li{margin:21px 0 0;display:flex;align-items: flex-start;}
.ChatPage .subject .dialogue ul li .avatar{display: inline-block;width: 40px;height:40px;background: #205CB0;text-align: center;line-height: 46px;border-radius: 50%;margin-right: 27px;}
.ChatPage .subject .dialogue ul li div{background:#2E3033;padding: 20px;border-radius: 10px;width: 100%;}
.ChatPage .subject .problem{max-width: 1260px;position: absolute;display: flex;bottom:5vh;left:0;width: 100%;}
.ChatPage .subject .problem i{width: 60px;background: #fff;height: 60px;display:inline-table;opacity:0;}
.ChatPage .subject .problem .QA{display: inline-block;height:70px;margin-left: 20px;width: 100%;line-height: 60px;padding:0 40px 0 15px;position: relative;background: #2e3033;border-radius:8px;overflow: hidden;}
.ChatPage .subject .problem .QA .input{position: absolute;top:0;left:0;width:100%;z-index:2;line-height: 100%;height:100%;background: none;padding:.4rem 0;}
.ChatPage .subject .problem .input textarea{height:100%;background: #2E3033;border:none;color: #fff;font-size:80%;}
.ChatPage .subject .problem .send_icon{position: absolute;right:2%;top:50%;width:30px;transform: translate(0,-50%);cursor: pointer;z-index: 5;}
/*滚动条样式*/
.ChatPage .broadside ul::-webkit-scrollbar {width:0px;height:0px;}
.ChatPage .subject .dialogue::-webkit-scrollbar { width: 0px;height: 0px;}
.ChatPage .subject .problem .input textarea::-webkit-scrollbar {width:0px;height:0px;}

        /* 宽度小于750的时候 */
        @media only screen and (max-width:750px) {
            .ChatPage .broadside{left:-100%;}
            .ChatPage .subject .problem .input{height: 40px;}
            .ChatPage .subject .problem i{width: 40px;height: 40px;}
            .ChatPage .subject .dialogue{height: 85vh;max-height: 95vh;}
            .ChatPage .subject .fold_icon{left:0;}
            .ChatPage .broadside ul li{font-size: 12px;}
            .ChatPage .broadside .sessionbtn{font-size: 12px;}
            .ChatPage .leftcontent{position: absolute;}
            .ChatPage .position{position: relative;width: 100%;max-width: 280px;}
            .ChatPage .broadside.flod{left:0;}
            .ChatPage .subjectcontent{width:40%;}
        }

@keyframes flicker{
    0%{opacity:1;}
    50%{opacity:0;}
    100%{opacity:1;}
}


</style>